
import { i18nText } from '@/locales';

import {Component, Vue, Watch} from "vue-property-decorator";
import FormGroup from "@/UI/components/common/form/FormGroup.vue";
import PageTitle from "@/UI/components/common/PageTitle.vue";

import {mixins} from "vue-class-component";
import {SimpleProxyForm} from "@/UI/components/Helpers/SimpleProxyForm";
import {ClientsMix} from "@/UI/mixins/ClientsMix";
import BaseDataForm from "@/UI/components/Helpers/BaseForm/BaseDataForm.vue";
import {VisitsGeneralMix} from "@/UI/mixins/Visits/VisitsGeneralMix";
import {VisitsStore} from "@/store/modules/Visits";
import {Button, FormModel, Input, List, Menu, Select, Table, Tabs, Row, Col, Tooltip} from "ant-design-vue";
import {ClientLoyaltyTableMix} from "@/UI/mixins/Loaylty/ClientLoyaltyTableMix";
import {LoyaltyCertMix} from "@/UI/mixins/Loaylty/LoyaltyCertMix";
import {SubscriptionMix} from "@/UI/mixins/Loaylty/SubscriptionMix";
import {SubscriptionTableMix} from "@/UI/mixins/Loaylty/SubscriptionTableMix";
import {CashBoxMix} from "@/UI/mixins/CashBoxMix";
import {CashboxStore} from "@/store/modules/Finance/Cashbox";
import {AppStateStore} from "@/store/modules/appState";
import {LoyaltyCertStore} from "@/store/modules/LoyaltyCert";
import {LoyaltySubscriptionStore} from "@/store/modules/Loyalty/Subscription/LoyaltySubscription";
import {PayMix} from "@/UI/pages/visitsNew/mixins/PayMix";
import {SearchMix} from "@/UI/pages/visitsNew/mixins/SearchMix";
import {RecordDataForm} from "@/form/visits/New/Record";
import {showNotificationSimple} from "@/UI/lib/messages";
import {RouterNameEnum} from "@/router/router.types";
import {ClientsStore} from "@/store/modules/Clients";
import {getStudioId} from "@/UI/lib/state";
import {getVisitData} from "@/UI/pages/visitsNew/Lib/support";
import {RecordParams, RecordParamsData} from "@/UI/pages/visitsNew/Lib/support";
import {CurrencyStore} from "@/store/modules/Currency";
import {SalonsStore} from "@/store/modules/Salons";
import {
  ILoyaltySubscriptionListItem
} from "@/entity/loyalty/loyaltySubscription/loyaltySubscription/LoyaltySubscription.types";
// // import {
// //     ILoyaltySubscriptionListItem,
// //     ILoyaltySubscriptions,
// // } from "@/entity/loyalty/loyaltySubscription/loyaltySubscription/LoyaltySubscription.types";

@Component({
  components: {
    FormGroup,
    PageTitle,
    BaseDataForm,
    "a-button": Button,
    "a-menu-item": Menu.Item,
    "a-list-item": List.Item,
    "a-list-item-meta": List.Item.Meta,
    "a-select": Select,
    "a-select-option": Select.Option,
    "a-table": Table,
    "a-input": Input,
    "a-tab": Tabs,
    "a-tab-pane": Tabs.TabPane,
    "a-form-model": FormModel,
    "a-form-model-item": FormModel.Item,
    "a-row": Row,
    "a-col": Col,
    "a-tooltip": Tooltip,
  },
})
export default class VisitPayment extends mixins(
    SimpleProxyForm,
    ClientsMix,
    VisitsGeneralMix,
    SimpleProxyForm,
    ClientLoyaltyTableMix,
    LoyaltyCertMix,
    SubscriptionMix,
    SubscriptionTableMix,
    CashBoxMix,
    PayMix,
    SearchMix,
) {
  certificateSearch = "";
  SubscribeSearch = "";
  startCertData: any[] = [];
  startSubsData: any[] = [];
  startClientData: any[] = [];
  service_name: string = "";
  service_cost: string = "";
  create_acc_user: boolean = false;
  form_create_acc: any = {};
  unsubscribe: any = null;
  services_length: any = null;
  create_acc: boolean = false;

  certificatesList: Record<string, any>[] = [];
  membershipsList: Record<string, any>[] = [];

  form = new RecordDataForm();

  renderLoaylty = false;

  @Watch("$store.state.appState.sendDelete", {immediate: false})
  async ButtonDelete(): Promise<void> {
    AppStateStore.setDelete(false);
    await this.deleteVisit(this.form);
  }

  @Watch("$store.state.appState.sendSubmit", {immediate: false})
  async ButtonSubmit(value: boolean): Promise<void> {
    AppStateStore.setUpdate(false);
    await this.updateVisit(value, this.form, RecordParams());
    if (this.visit.order.paid !== this.visit.order.sum) {
      showNotificationSimple(i18nText("Визит оплачен частично"), "", 10);
    }
  }

  @Watch("$store.state.appState.sendCancel", {immediate: false})
  async ButtonCancel(value: boolean): Promise<void> {
    AppStateStore.setCancel(false);
    await this.pushToCalendar(this.form, RecordParams());
    if (this.visit.order.paid !== this.visit.order.sum) {
      showNotificationSimple(i18nText("Визит оплачен частично"), "", 10);
    }
  }

  pushToBox(data: Record<any, any>): void {
    this.boxData.push(data);
  }

  paymentLimitation(val: any): void {
    let target = val.target.value
    this.unsubscribe = target.substring(0, 7)
    this.formVisit.sum = target.substring(0, 7)

    if ((this.formVisit.sum as any) < 0) this.formVisit.sum = 0, this.unsubscribe = 0
  }

  handlePayCancel(): void {
    this.showPayModal = false;
  }

  async handlePayOk(): Promise<void> {
    //this.showPayModal = false;
    this.formVisit.visit_id = Number(Vue.router.currentRoute.params["id"]);

    try {
      this.showPayModal = false;
      this.formReady = false;
      if (this.create_acc_user) {
        await ClientsStore.createPaymentAccount(this.form_create_acc);
      }
      if (this.visit.order.paid === this.visit.order.sum) {
        showNotificationSimple(i18nText("Оплата визита невозможна, визит уже оплачен"), "", 10);
      } else {
        const response = await VisitsStore.pay(this.formVisit);
        if (!response.status && response.response) {
          showNotificationSimple(response.response, "", 10);
          return;
        }

        await VisitsStore.fetchData({filter: {id: this.visit_id}});
        this.paymentMethods = await VisitsStore.fetchPaymentMethods({visit_id: this.visit_id});
        if (this.visit.order.paid === this.visit.order.sum) {
          if (!this.formVisit.certificate_id
              && !this.formVisit.membership_id
              && !this.formVisit.account_pay) {

            if (Number(this.formVisit.sum) === this.visit.order.sum) {
              showNotificationSimple(i18nText("Визит успешно оплачен"), "", 10);
            } else {
              let code = SalonsStore.salons?.data[0].currencies.code
              showNotificationSimple(i18nText('Визит оплачен полностью, на счет клиента зачислено {amount} {currency}', {amount: Number(this.formVisit.sum) - this.visit.order.sum, currency: code === undefined ? '₽' : code}), "", 10);
            }
          } else {
            showNotificationSimple(i18nText("Визит успешно оплачен"), "", 10);
          }
          await Vue.router.push({
            name: RouterNameEnum.VisitsNewPayReport,
            params: {
              form: JSON.stringify({form: this.formVisit, response: response}),
            },
          });
        } else {
          if (this.create_acc_user) {
            let code = SalonsStore.salons?.data[0].currencies.code
            showNotificationSimple(i18nText("Визит оплачен полностью"), "", 10);
            showNotificationSimple(i18nText('На счет клиента зачислено {amount} {currency}', {amount: Number(this.formVisit.sum) - this.visit.order.sum, currency: code === undefined ? '₽' : code}), "", 10);
          } else {
            showNotificationSimple(i18nText("Визит оплачен частично"), "", 10);
          }
        }
      }
    } catch (e: any) {
      showNotificationSimple(i18nText("Ошибка платежа"), e, 10);
    } finally {
      await this.fetchPaymentsMethods();
      //await this.getData(); // Лишние запросы. Стоит убрать и посмотреть в дальнейшем
      this.formReady = true;
      this.create_acc_user = false;
    }
  }

  create_account(): void {
    this.form_create_acc = {
      cashbox_id: this.formVisit.cashbox_id,
      payment_method_id: null,
      staff_id: this.visit.staff.id,
      client_id: this.startClientData[0].id,
      salon_id: getStudioId(this),
      sum: 0,
    };
    this.create_acc = false;
    this.showPayModal = true;
    this.create_acc_user = true;
  }

  zeroСheck(): any {
    let check: boolean = false
    if (this.formVisit.sum === 0 || (this.formVisit.sum as any) === '0') {
      this.$message.error(i18nText("Указанная сумма должна быть больше 0"))
      return
    } else if (!this.formVisit.sum) {
      this.$message.error(i18nText("Не введена сумма для оплаты"))
      return
    }
    this.showPayModal = true;
    return check = true
  }

  cancelCreateAcc(): void {
    this.showPayModal = true;
  }

  handleCashboxPayment(id: number): void {
    if (!this.zeroСheck()) return

    this.formVisit.cashbox_id = id;
    this.formVisit.certificate_id = null;
    this.formVisit.membership_id = null;
    this.formVisit.account_pay = false;
    this.formVisit.account_pay_partial = false;
    this.visibleCashCashboxes = false;
    this.visibleCardCashboxes = false;

    if (
        !this.startClientData[0].account &&
        Number(this.formVisit.sum) > Number(this.visit.order.sum) - Number(this.visit.order.paid)
    ) {
      this.showPayModal = false
      this.create_account() // === this.create_acc = true, then ok
    }
  }

  handleCertificatePayment(record: Record<any, any>): void {
    //if (!this.zeroСheck()) return

    this.formVisit.cashbox_id = null;
    this.formVisit.certificate_id = record.id;
    this.formVisit.membership_id = null;
    this.formVisit.account_pay = false;
    this.formVisit.account_pay_partial = false;
    // this.formVisit.sum = record.cost;
    //this.service_name = record.type.name;
    this.service_name = record.code;
    // this.service_cost = record.balance;
    if (Number(record.balance) > Number(this.formVisit.sum)) {
      this.formVisit.sum = this.visit.order.sum - this.visit.order.paid as any
      this.service_cost = this.visit.order.sum - this.visit.order.paid as any
    } else {
      this.formVisit.sum = record.balance
      this.service_cost = record.balance
    }
    this.showPayModal = true;
  }

  handleMembershipPayment(record: Record<any, any>): void {
// console.error(record)
    // this.services_length = this.visit.services.length;
    // this.services_length = record.services.length
    this.services_length = 1
    this.formVisit.cashbox_id = null;
    this.formVisit.membership_id = record.id;
    this.formVisit.certificate_id = null;
    this.formVisit.account_pay = false;
    this.formVisit.account_pay_partial = false;
    this.formVisit.sum = record.cost;
    this.service_name = record.type.name;
    this.service_cost = this.visit.order.sum;

    this.showPayModal = true
  }

  handleAccountPayment(record: Record<any, any>): void {
    if (!this.zeroСheck()) return

    this.formVisit.cashbox_id = null
    this.formVisit.membership_id = null
    this.formVisit.certificate_id = null

    if (this.formVisit.sum) {
      this.formVisit.account_pay_partial = true;
      this.formVisit.account_pay = false;

      if (Number(this.visit.order.sum) > Number(this.startClientData[0].account.balance) &&
          Number(this.formVisit.sum) > Number(this.startClientData[0].account.balance)
      ) {
        this.formVisit.sum = this.startClientData[0].account.balance
        this.unsubscribe = this.startClientData[0].account.balance
      } else if (Number(this.visit.order.sum) < Number(this.startClientData[0].account.balance) &&
          Number(this.formVisit.sum) > Number(this.visit.order.sum)
      ) {
        this.formVisit.sum = this.visit.order.sum
        this.unsubscribe = this.visit.order.sum
      }
    } else {
      this.formVisit.account_pay = true;
      this.formVisit.account_pay_partial = false;
      this.formVisit.sum = this.visit.order.sum - this.visit.order.paid;
    }
  }

  toggleSearchLoyaltyBlock(): void {
    this.showSearchLoyaltyBlock = this.showSearchLoyaltyBlock ? false : true;
  }

  get cash_cashboxes(): any {
    if (this.cashBoxes && this.cashBoxes.data) {
      return this.cashBoxes.data.filter((e) => e && e.type && e.type.id == 1);
    } else {
      return [];
    }
  }

  get card_cashboxes(): any {
    if (this.cashBoxes && this.cashBoxes.data) {
      return this.cashBoxes.data.filter((e) => e && e.type && e.type.id == 2);
    } else {
      return [];
    }
  }

  async getData(): Promise<void> {
    //await this.parseVisit(Number(Vue.router.currentRoute.params["id"]));
    await getVisitData(Number(Vue.router.currentRoute.params["id"]), VisitsStore);

    await this.form.parseVisitData(this.visit);

    this.visit_id = Number(Vue.router.currentRoute.params["id"]);
    this.client_id = Number(this.form.client_id);

    //await LoyaltyCertStore.fetchAll({filter: {client_id: this.client_id}});
    //await LoyaltySubscriptionStore.fetchAll({filter: {client_id: this.client_id}});
    await ClientsStore.fetchAll({filter: {id: this.client_id}});

    this.startCertData = [...this.Certificates];
    this.startSubsData = [...this.Subscriptions];
    this.startClientData = this.ClientsAcc;

    await ClientsStore.clearItems();
    //await LoyaltyCertStore.clearItems();
    //await LoyaltySubscriptionStore.clearItems();

    await this.fetchPaymentsMethods();

    this.renderLoaylty = true;
  }

  async fetchPaymentsMethods(): Promise<void> {
    this.certificatesList = [];
    this.membershipsList = [];

    this.paymentMethods = await VisitsStore.fetchPaymentMethods({visit_id: this.visit_id});

    if (this.paymentMethods.certificates) {
      this.paymentMethods.certificates.forEach((item: Record<string, any>) => {
        //this.paymentMethods.certificates[index]['template'] = 'certificate';
        item['template'] = 'certificate';
      })
    }
    if (this.paymentMethods.memberships) {
      this.paymentMethods.memberships.forEach((item: Record<string, any>) => {
        //this.paymentMethods.certificates[index]['template'] = 'certificate';
        item['template'] = 'subscription';
      })
    }

    this.resetMembershipsList();
    this.resetCertificatesList();
  }

  resetCertificatesList(): void {
    if (this.paymentMethods.certificates) {
      this.certificatesList = [...this.paymentMethods.certificates];
    }
  }

  resetMembershipsList(): void {
    if (this.paymentMethods.memberships) {
      this.membershipsList = [...this.paymentMethods.memberships];
    }
  }

  async searchMembership(value: string): Promise<void> {
    this.resetMembershipsList();
    if (value.length) {
      this.membershipsList = this.membershipsList.filter((item) => {
        return String(item.membership_number).includes(value)
      })
    }
    /*if (value.length > 0) {
      await LoyaltySubscriptionStore.clearItems();
      await LoyaltySubscriptionStore.fetchAll({filter: {membership_number: value}});
    } else {
      await LoyaltySubscriptionStore.clearItems();
    }*/
  }

  async certSearch(value: string): Promise<void> {
    this.resetCertificatesList();
    if (value.length) {
      this.certificatesList = this.certificatesList.filter((item) => {
        return String(item.code).includes(value)
      })
    }
    /*if (value.length > 0) {
      await LoyaltyCertStore.clearItems();
      await LoyaltyCertStore.fetchAll({filter: {code: Number(value)}});
    } else {
      await LoyaltyCertStore.clearItems();
    }*/
  }

  get rData(): any[] {
    let data: any[] = [];
    if (this.Certificates && this.Certificates.length > 0) {
      Object.assign(data, this.Certificates);
    }

    if (this.ClientsAcc && this.ClientsAcc.length > 0) {
      Object.assign(data, this.ClientsAcc);
    }
    if (this.startCertData && this.startCertData.length > 0) {
      this.startCertData.map((cert) => {
        data.push(cert);
      });
    }

    if (this.certificatesList.length) {
      data = [...data, ...this.certificatesList];
    }

    /*if (this.startSubsData && this.startSubsData.length > 0) {
      if (this.paymentMethods && this.paymentMethods.memberships !== undefined) {
        // TODO::Chaeck payment methodts
        this.startSubsData.map((membership: ILoyaltySubscriptionListItem) => {
          // @ts-ignore
          const result = (this.paymentMethods.memberships as ILoyaltySubscriptions.data).find(
              (data: ILoyaltySubscriptionListItem) => data.id === membership.id,
          );
          if (result && Number(result.balance) > 0) {
            data.push(membership);
          }
        });
      }
    }*/

    if (this.membershipsList.length) {
      data = [...data, ...this.membershipsList];
    }

    if (this.startClientData && this.startClientData.length > 0) {
      if (this.startClientData[0].account) {
        this.startClientData.map((clacc) => {
          data.push(clacc);
        });
      }
    }

    return data;
  }

  async created(): Promise<void> {
    await this.getData();

    try {
      await CashboxStore.fetchAll({filter: {salon_id: this.form.salon_id}});
      await VisitsStore.fetchData({filter: {id: this.visit_id}});

      //let data = await VisitsStore.fetchPaymentMethods({ visit_id: this.visit_id });

      //if (Object.keys(data)[0] === "certificates") this.paymentMethods.certificates = data.certificates;
      //if (Object.keys(data)[0] === "memberships") this.paymentMethods.memberships = data.memberships;

      if (this.visit && this.visit.client) {
        this.maskedPhone = this.visit.client.phone.replace(
            /(\d{1})(\d{3})(\d{3})(\d{2})(\d{2})/,
            "+$1 $2 $3-$4-$5",
        );

        if (this.visit.basket) {
          for (let i = 0; i < this.visit.basket.services.length; i++) {
            let service = this.visit.basket.services[i];

            let totalPrice =
                service.price * service.quantity - (service.discount * service.price) / 100;
            this.pushToBox({
              key: service.service_id,
              name: service.service.name,
              total: totalPrice,
            });
          }
          for (let i = 0; i < this.visit.basket.products.length; i++) {
            let product = this.visit.basket.products[i];
            let totalPrice =
                product.price * product.quantity - (product.discount * product.price) / 100;
            this.pushToBox({
              key: product.product_id,
              name: product.product.nomenclature.name,
              total: totalPrice,
            });
          }
          for (let i = 0; i < this.visit.basket.certificates.length; i++) {
            let certificate = this.visit.basket.certificates[i];
            let totalPrice =
                certificate.price * certificate.quantity -
                (certificate.discount * certificate.price) / 100;
            this.pushToBox({
              key: certificate.certificate_id,
              name: i18nText("Сертификат №") + certificate.certificate.code,
              total: totalPrice,
            });
          }
          for (let i = 0; i < this.visit.basket.memberships.length; i++) {
            let membership = this.visit.basket.memberships[i];
            let totalPrice =
                membership.price * membership.quantity - (membership.discount * membership.price) / 100;
            this.pushToBox({
              key: membership.membership_id,
              name: i18nText("Абонемент №") + membership.membership.membership_number,
              total: totalPrice,
            });
          }
        }
      }
    } catch (e) {
      console.log("error parse Visit Data");
    } finally {
      this.tableLoad = true;
      this.formReady = true;

      // console.error(this.rData);
    }
  }
}
